/**
 * Author: Francisco Edgardo Hernández Palacios
 * File description: This services will serve to have methods or functions that can be reused in other components
 */

// Essential Imports
import { Injectable } from '@angular/core';

// Angular Firebase
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireMessaging } from '@angular/fire/messaging';

// Sweetalert
import Swal from 'sweetalert2'

// mModal de Ant Design
import { NzModalService } from 'ng-zorro-antd';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable()
export class GlobalServices {

  public urlImagen: string;

  constructor(
    private auth: AngularFireAuth,
    private db: AngularFirestore,
    private storage: AngularFireStorage,
    private messaging: AngularFireMessaging,
    private nzModal: NzModalService,
  ) { }

  // Extraer usuario logeado
  getUsuario() {
    return this.auth.authState
  }

  // * ==> Fechas <== *//

  // Generar la fecha actual en string
  generateCurrentDate() {
    let fecha = new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
    let horas = new Date().getHours();
    let min = new Date().getMinutes();
    let seg = new Date().getSeconds();

    let endfecha = `${fecha} ${((horas < 10) ? '0' : '') + horas}:${((min < 10) ? '0' : '') + min}:${((seg < 10) ? '0' : '') + seg}`;

    return endfecha;
  }

  // Parse Timestamp a Date
  calculeDateTimestamp(dateTimestamp) {
    let a = new Date(dateTimestamp * 1000);

    let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let sec = a.getSeconds();
    let time = date + '/' + month + '/' + year + ' ' + hour + ':' + min + ':' + sec;
    return time;
  }


  // Generar fecha mayor a fecha actual
  generateDateExpire(dias: number) {
    let anio = new Date().getUTCFullYear();
    let entrega = new Date();
    entrega.setUTCFullYear(anio);
    // A la fecha que genera sumarle dias
    entrega.setDate(entrega.getDate() + dias);

    let fecha = new Date(entrega);
    let endfecha = `${fecha}`;
    return endfecha;
  }

  // * ==> Storage <== *//

  // Capturar la URL de la imagen
  obtainUrlImage(filePath: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const ref = this.storage.ref(filePath);
      // Obteniendo la Direccion de la Imagen
      try {
        ref.getDownloadURL().subscribe((res) => {
          resolve(res);
        }, (error) => {
          reject(error);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  // Subir imagen a Storage
  async uploadImage(filePath: string, file) {

    await this.storage.upload(filePath, file);
    const ref = this.storage.ref(filePath);
    // Obteniendo la Direccion de la Imagen
    ref.getDownloadURL().subscribe((res) => this.urlImagen = res);
    return await this.urlImagen;
  }

  // Actualizar imagen de Storage
  async updateImage(filePath: string, file) {
    // Elimina la imagen anterior
    await this.deleteImage(filePath).then(() => {
      // Subir nueva imagen
      this.uploadImage(filePath, file);
    });
  }

  // Eliminar imagen de Storage
  async deleteImage(filePath: string) {
    // Referencia a la imagen
    const ref = this.storage.ref(filePath);
    ref.delete();
  }

  // * ==> Messaging <== *//

  getToken() {
    return new Promise((resolve, reject) => {
      this.messaging.getToken.subscribe((snap) => {
        resolve({ ok: true, token: snap });
      }, (e) => {
        resolve({ ok: false });
      });
    });
  }


  // * ==> Alertas de NGZorro <== *//

  // Modal basic alert basic
  ngModalAlert(tipo: string, titulo: string, contenido: string,  func?: Function): void {
    this.nzModal[tipo]({
      nzTitle: titulo,
      nzContent: contenido,
      nzOnOk: () => func && func()
    });
  }

  ngModalAlertDelete(tipo?: string, titulo?: string, contenido?: string,  func?: Function,loading?: boolean): void {
    this.nzModal[tipo]({
      nzTitle: titulo,
      nzContent: contenido,
      nzOkLoading:loading,
      nzOnOk : () => func && func()
    });

  }

  // * ==> Alertas de Sweetalert <== *//

  // Modal basic alert Sweetalert
  sweetalertBasic(tipo, titulo, texto, footerText) {
    Swal.fire({
      icon: tipo,
      title: titulo,
      text: texto,
      footer: footerText
    })
  }

  // Modal min alert Sweetalert
  sweetalertMix(timer: number, tipo, title) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });

    Toast.fire({
      icon: tipo,
      title: title
    });
  }

}
